import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useLoginStore } from "@/Modules/Auth/Login/Store";
import { useRedirect } from "@/hooks";
import useApi, { ApiRequestError } from "@/hooks/useApi";
import { useCompanyStore, useLoggedUserStore } from "@/Store";
import S from "./styles.module.scss";

const RequiredAuth = () => {
  const sessionId = useLoginStore((state) => state.sessionId);
  const { clearSession } = useLoginStore();
  const redirect = useRedirect();
  const { getRequest } = useApi();
  const loggedUser = useLoggedUserStore((state) => state.loggedUser);
  const setLoggedUser = useLoggedUserStore((state) => state.setLoggedUser);
  const clearCompanyContext = useCompanyStore(
    (state) => state.clearCompanyContext
  );
  const [authUnavailable, setAuthUnavailable] = useState(false);
  const [retryKey, setRetryKey] = useState(0);

  useEffect(() => {
    if (!sessionId) return;
    let active = true;
    const loadUser = async () => {
      setAuthUnavailable(false);
      try {
        const response = await getRequest("/api/user");
        const user = await response.json();
        if (active) setLoggedUser(user);
      } catch (requestError: unknown) {
        let effectiveError = requestError;
        if (
          requestError instanceof ApiRequestError &&
          requestError.status === 403
        ) {
          // Recupera apenas uma empresa persistida que não pertence à sessão.
          clearCompanyContext();
          try {
            const response = await getRequest("/api/user");
            const user = await response.json();
            if (active) setLoggedUser(user);
            return;
          } catch (retryError: unknown) {
            effectiveError = retryError;
          }
        }
        if (!active) return;
        if (
          effectiveError instanceof ApiRequestError &&
          effectiveError.status === 401
        ) {
          setLoggedUser(null);
          clearSession();
          redirect("/login");
          return;
        }
        // Rede/5xx não invalidam uma sessão válida nem apagam a empresa.
        setAuthUnavailable(true);
      }
    };
    loadUser();
    return () => {
      active = false;
    };
  }, [sessionId, retryKey]);

  if (!sessionId) return <Navigate to="/login" replace />;

  // Aguarda a reidratação do usuário para evitar 404 em rotas protegidas no reload.
  if (sessionId && !loggedUser) {
    if (authUnavailable) {
      return (
        <div className={S.loaderWrap} role="alert">
          <p>Não foi possível validar sua sessão agora.</p>
          <button type="button" onClick={() => setRetryKey((value) => value + 1)}>
            Tentar novamente
          </button>
        </div>
      );
    }
    return (
      <div className={S.loaderWrap}>
        <div className={S.loader}></div>
      </div>
    );
  }

  return <Outlet />;
};

export default RequiredAuth;
